<template>
    <v-container class="bg-white" :class="data.class">
        <v-row>
            <v-col cols="12" md="10" class="mx-auto" >
                <v-card :loading="!content" theme="light">
                    <div v-html="content"></div>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>



<script>
import axios from 'axios';

export default {
    name: 'uibenda-component',
    components:{
        // 'cookie-banner': CookieBanner
    },
    props:{
        data:{
            type: Object,
            required: true,
        }
    },
    computed:{
        
    },
    
    data: () => ({
       content: null,
    }),
    mounted(){
       if(this.data.iubenda_link){  
         this.getIubendaContent(this.data.iubenda_link)
       }
    },
    methods:{
        async getIubendaContent(link){
            await axios.get(link).then((response) => {
              this.content = response.data.content
           })
        }
    }
}
</script>


<style lang='scss'>

    @import 'https://www.iubenda.com/assets/privacy_policy.css'

</style>